"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
  },
};

export default function NotFoundClient() {
  return (
    <main className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-24">
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="flex max-w-lg flex-col items-center gap-6 text-center"
      >
        {/* Big 404 */}
        <motion.p
          variants={item}
          className="text-[7rem] font-extrabold leading-none tracking-tighter text-[var(--accent)] opacity-20 sm:text-[9rem]"
        >
          404
        </motion.p>

        {/* Heading */}
        <motion.h1
          variants={item}
          className="-mt-6 text-2xl font-bold tracking-tight text-[var(--foreground)] sm:text-3xl"
        >
          Page not found
        </motion.h1>

        {/* Subtext */}
        <motion.p
          variants={item}
          className="text-base leading-relaxed text-[var(--foreground-muted)]"
        >
          The page you&apos;re looking for doesn&apos;t exist or may have been moved. Let&apos;s get
          you back on track.
        </motion.p>

        {/* Buttons */}
        <motion.div variants={item} className="flex flex-wrap items-center justify-center gap-3">
          <Link
            href="/"
            className="group inline-flex items-center gap-2 rounded-full bg-[var(--accent)] px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-85"
          >
            <Home size={15} />
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-full border border-[var(--border)] px-6 py-3 text-sm font-medium text-[var(--foreground-muted)] transition-colors hover:border-[var(--accent)] hover:text-[var(--foreground)]"
          >
            <ArrowLeft size={15} />
            Go back
          </button>
        </motion.div>
      </motion.div>
    </main>
  );
}
